import axiosClient from '@/axios'

const register = async user => {
   return await axiosClient.post('/register', user);
}

export default {
   register
}
